<template>
  <div class="book">
    <div class="page left">
      <h1>此兵法の書、五卷に仕立事</h1>

      <div class="text_left" v-for="(block, index) in japaneseBlocks" :key="'ja-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>

    <div class="page right">
      <div class="video">
        <div class="video-container">
          <iframe :src="youtubeEmbedUrl" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <h2>此兵书五卷分之</h2>

      <div v-for="(block, index) in chineseBlocks" :key="'zh-'+index">
        <p class="kobun block"><strong>{{ block.kobun }}</strong></p>
        <p class="genndaibun">{{ block.translation }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
const youtubeEmbedUrl = "https://www.youtube.com/embed/YOUR_VIDEO_ID";

const japaneseBlocks = [
  { kobun: "此兵法の書、五巻に仕立つる事", translation: "この兵法の書を、五巻に仕立てる事" },
  
  { kobun: "五ツの道をわかち、一巻一巻にして、其利をしらしめんために、地水火風空として、五巻に書顕すなり。", translation: "五つの道を分け、一巻ずつにして、その（道の）利を教えるために、地・水・火・風・空の五巻に書きあらわすのである。" },
  
  { kobun: "地之巻におゐてハ、兵法の道の大躰、我一流の見立、劔術一通りにしてハ、まことの道を得がたし。", translation: "地之巻においては、兵法の道の概略、我が流派の見立てるところ、剣術だけをやっていては真実の道は得がたい。" },
  
  { kobun: "大きなる所よりちいさき所を知り、浅きより深きに至る。", translation: "大きな所から小さい所を知り、浅いことから深いことへ至る" },
  
  { kobun: "直なる道の地形を引きならすによつて、初を地の巻と名付くる也。。", translation: "まっすぐな道の地形を整地してならすことから、最初の巻を「地の巻」と名づけたのである。" },

  { kobun: "第二、水之巻。水を本として、心を水になす也。", translation: "第二は「水の巻」。水を手本として、心を水のように柔軟にすること。" },

  { kobun: "水ハ、方圓の器にしたがひ、一てきとなり、さうかいとなる。", translation: "水は、容器に合わせて四角にも丸にもなる。ほんの一滴のときもあれば、果てしない大海になることもある。" },

  { kobun: "水に碧の色あり、きよき所をもちひて、一流のことを此巻に書顕はす也。", translation: "水には、深い淵のような青緑の色がある。その清らかな性質にならい、この巻では我が流派について記すことにする。" },

  { kobun: "剣術一通の理、さだかに見分、一人の敵に自由に勝ときハ、世界の人に皆勝所也。", translation: "剣術の道理をしっかりと見極め、一人の敵に自在に勝てるようになれば、世の中のどんな相手にも勝てるようになる。" },
  
  { kobun: "人に勝つといふ心は千万の敵にも同意なり。将たるものの兵法、ちいさきを大きになす事、＊尺のかたをもつて大仏をたつるに同じ。か様の義、こまやかには書分けがたし。", translation: "「人に勝つ」とは、たとえ相手が千人でも万人でも、意味は変わらない。武士の兵法とは、小さなことを大きく応用するものであり、それは、物差し（曲尺）を使って大仏を建てるのと同じことである。これらのことは細かく説明するのは難しいが、"},

  { kobun: "一をもつて万と知る事、兵法の利也。一流の事、此水の巻に書きしるす也。",translation: "「一つを知ってすべてに通じる」——それこそが兵法の本質である。そこで、この「水の巻」には我が流派の教えを記すことにする。" },

  { kobun: "第三、火之巻。此巻に戦の事を書記す也。", translation: "第三は「火の巻」。この巻では、戦いについて述べていく。"},

  { kobun: "火は大小となり、＊けやけき心なるによつて、合戦の事を書く也。", translation: "火は、大きくなったり小さくなったり（自在に変化し）、きわだって派手なところがあることから、合戦の事を書くのである。"},

  { kobun: "合戦の道、一人と一人との戦も、萬と萬との戦も同じ道也。", translation: "合戦においては、一対一の戦いも、万人同士の戦いも、本質は同じである。"},

  { kobun: "心を大きなる事になし、心をちいさくなして、よく吟味して見るべし。", translation: "心を大きく持ったり、小さく絞ったりして、よく深く考えて見極めることが大切である。"},

  { kobun: "大きなる所は見えやすし、ちいさき所は見えがたし。", translation: "大きな所は見えやすいが、小さな所は見えにくい。"},

  { kobun: "其子細、大人数の事は＊即座にもとをりがたし。", translation: "その理由は、大勢のことはすぐに変えるのが難しいからであるが、"},

  { kobun: "一人の事は心一つにてかわる事はやきによつて、ちいさき所しる事得がたし。", translation: "一人の動きは、心ひとつで素早く変わるため、かえって細かいところを見極めるのは難しいからである。"},

  { kobun: "能く吟味有るべし。", translation: "（この点を）よく吟味しておくべきである。"},

  { kobun: "此火の巻の事、＊はやき間の事なるによつて、＊日々に手馴れ、常のごとくおもひ、＊心のかはらぬ所、兵法の肝要也。", translation: "この「火の巻」で説いているのは、瞬時の変化への対応についてである。そのためには、日々訓練を重ね、日常のことのように自然に行動し、心を乱さないこと――それこそが兵法の要なのである。"},

  { kobun: "然るによつて、戦勝負の所を火の巻に書顕はす也。", translation: "それゆえ、戦さ勝負のところを「火」の巻に書きあらわすのである。"},

  { kobun: "第四、風之巻。此巻を風之巻と記す事、我一流の事に非ず。世の中の兵法、其流々の事を書のする所也。", translation: "第四は「風の巻」。この巻を「風の巻」と名づけたのは、我が流派のことではなく、世にあるさまざまな兵法・流派について記すためである。"},

  { kobun: "風といふにおゐては、むかしの風、今の風、その家々の風などとあれば、世間の兵法、其流々のしわざを、さだかに書顕はす、是風也。", translation: "「風」とは、昔の流儀、今の流儀、各家の流派ごとの特徴などを意味する。そこでこの巻では、世の中に伝わるさまざまな兵法や流派のやり方を、明確に書き記しておく。それが「風の巻」の意味である。"},

  { kobun: "他の事をよくしらずしてハ、ミずからのわきまへなりがたし。", translation: "他の（流派の）事をよく知らずしては、自身の理解も成りがたい。"},

  { kobun: "道々事々をおこなふに、＊外道といふ心あり。", translation: "さまざまな道において物事を行う中で、「外道（げどう）」という考えが生まれることがある。"},

  { kobun: "日々に其道を勤むるといふとも、＊心のそむけば、其身はよき道とおもふとも、直なる所より見れば、実の道にはあらず。", translation: "たとえ日々その道に励んでいたとしても、心が道から外れていれば、本人が正しいと思っていても、正しい立場から見ればそれは本当の道ではない。"},

  { kobun: "実の道は極めざれば、少し心のゆがみに付けて、後には大きにゆがむもの也。", translation: "真の道を極めようとしなければ、たとえ最初はわずかな心のゆがみであっても、やがては大きな誤りへとつながってしまうものである。"},

  { kobun: "吟味すべし。", translation: "これをよく吟味すべし"},

  { kobun: "他の兵法、剣術ばかりと世に思ふ事、＊尤也。我兵法の＊利わざにおゐても、各別の義也。", translation: "他流の兵法について、世間の人々がそれをただの剣術だと思ってしまうのは、ある意味当然のことだ。"},

  { kobun: "我兵法の＊利わざにおゐても、各別の義也。", translation: "我が兵法における技や理（ことわり）は、他の流派とはまったく異なっている。"},

  { kobun: "世間の兵法をしらしめんために、風の巻として、他流の事を書顕はす也。", translation: "世間における兵法がどのようなものかを広く知らせるために、「風の巻」として他流派の内容を書き記しているのである。"},

  { kobun: "第五、空之巻。此巻、空と書顕す事。空と云出すよりしてハ、何をか奥と云、何をかくちといはん。", translation: "第五、空〔くう〕之巻。この巻を、「空」と書きあらわすわけは、（以下のようなことだ）" },

  { kobun: "道理を得ては道理をはなれ、兵法の道に、おのれと自由ありて、おのれと＊奇特を得、＊時にあいては＊ひやうしを知り、＊おのづから打ち、おのづからあたる、是みな空の道也。", translation: "「空」と言うからには、何が奥で何が入口なのか？──いや、そもそもそんな区別は存在しない。道理を本当に理解すれば、やがてその道理を超えて、兵法の道に自然と自由が生まれ、自然と不思議なほどの優れた効果（奇特）を得るようになる。時の流れに応じて拍子（リズム）を察し、自然と打ち、自然と当たる。これこそが「空の道」である。" },
  
  { kobun: "おのれと実の道に入る事を、空の巻にして書きとゞむるもの也。", translation: "自然と真実の道に至るということを、「空の巻」に記して残しているのである。" },
  
  
  // ... 其他日文区块内容继续补充
];

const chineseBlocks = [
  { kobun: "此兵法书，分为五卷。", translation: "本兵法书共分五卷" },
  { kobun: "五道各自成卷，以示其利，故立地、水、火、风、空五卷。", translation: "按五种道理分别成章，以便让人理解其中的奥义，因此设立地、水、火、风、空五卷。" },
  { kobun: "地之卷者，述兵法之大略，吾流派之见解，若仅习剑术一途，难得真道。", translation: "地之卷主要阐述兵法的基本原则，以及本流派的理解。仅仅修习剑术，是无法真正领悟兵法之道的。" },
  { kobun: "由大观知细微，自浅入深，渐悟其理。",translation: "从大处了解小处，由浅显逐步深入，领悟其理。" },
  { kobun: "由整直之道形以为始，故名初卷为地之卷。", translation: "因整平笔直之地形为起点，故将第一卷命名为地之卷。" },
  { kobun: "次则水之卷。以水为本，心如流水。水随器形，或方或圆，或滴成小珠，或汇成沧海。", translation: "第二卷为水之卷。取水为象，使心境如水。水能随容器之形变方圆，可汇聚成滴，也可扩展为汪洋。" },
  { kobun: "水随方圆之器，可为一滴，亦可成沧海。", translation: "水依器成形，可小至一滴，亦可浩瀚如大海。" },
  { kobun: "水有碧色，取其清澄，故于此卷记我一流之理。", translation: "水具青碧之色，取其澄澈之性，于此卷中记述我流派之法。" },
  { kobun: "若明辨剑理之全，能自在胜一敌，则可胜天下之人。", translation: "若能明确掌握剑术的道理，自在战胜一人，便可战胜世间所有之人。" },
  { kobun: "勝人之理，縱敵千萬，亦同一義。武將之兵法，以小成大，猶以曲尺建大佛。此等之義，難以細述。", translation: "所谓战胜他人，即使敌人为千万人，理义亦同。将者之兵法，在于以小致大，正如以曲尺建造大佛。此类道理，难以详尽分述。" },
  { kobun: "以一知万，乃兵法之利也。故于此水之卷，记我一流之法。", translation: "以一知万，正是兵法的精髓。因此在这《水之卷》中，记述我流派之教义。" },
  { kobun: "第三、火之巻。于此巻记战之事也。", translation: "第三卷为《火之卷》，在此卷中记述战争之理。" },
  { kobun: "火可大可小，性烈而显，故于此卷记合战之事。", translation: "火可大可小，性烈而显，故此卷用以记述合战之理。" },
  { kobun: "合戦之道，无论一对一，或万对万，其理一也。", translation: "合战之道，无论是一对一，还是万人对万人，其本质皆相同。" },
  { kobun: "心可大可小，须细察深思而明其理。", translation: "应时而调心境，或放大或收缩，细致思考，方能洞察真理。" },
  { kobun: "大处易见，小处难察。", translation: "大处容易看见，小处却难以察觉。" },
  { kobun: "其细故，大众之事难以即变。", translation: "其原因在于，大规模之事难以立刻改变。" },
  { kobun: "一人之事，心动则速变，故反难察其细。", translation: "一人之事因心念一动即可迅速变化，反而难以把握细微之处。" },
  { kobun: "须当善加吟味。", translation: "对此应当仔细斟酌。" },
  { kobun: "此火之巻论速变之理，故须日练成习，常心不乱，乃兵法之要。", translation: "本《火之卷》所述乃应对迅速变化之道，唯有日常训练成自然，保持心境不变，方为兵法之精要。" },
  { kobun: "是故将战争胜负之理，记于火之卷中。", translation: "因此，将关于战争胜负的道理记述于《火之卷》中。" },
  { kobun: "第四、風之巻。名此巻為風者，非記我流，乃述世間诸流兵法之事。", translation: "第四卷为《风之卷》，之所以命名为风，并非记述我流派，而是记载世间诸多兵法流派之事。" },
  { kobun: "所谓風，指昔日之风、今时之风、诸家之风，故于此卷明记世间兵法诸流之术，此即風之意也。", translation: "所谓『风』，指的是古今流派与各家的风格，因此本卷将世间各种兵法流派的做法详实记述，这便是《风之卷》的意义。" },
  { kobun: "不知他流之事，则难以明自家之理。", translation: "若不熟知他派之法，便难以真正理解自身的道理。" },
  { kobun: "诸道诸事之行，常有外道之心生焉。", translation: "在修习各种道与技艺的过程中，往往会滋生出所谓的『外道』之心。" },
  { kobun: "纵日勤其道，若心背其道，虽自以为正，于真道而言，实非其然。", translation: "即便每日勤修其道，若心已违背，即使自觉正道，在真正的标准下，也不是真正的道。" },
  { kobun: "不极真道，虽初心稍偏，终将大谬。", translation: "若不致力于追求真道，即使起初只是微小的心之偏差，最终也会酿成巨大的误入。" },
  { kobun: "宜深加吟味。", translation: "对此应好好加以审慎判断。" },
  { kobun: "世人以他流兵法仅视为剑术，亦属情理之中；然我兵法之利技，义理自异。", translation: "世人将他派兵法仅当作剑术看待，也算情有可原；但我流兵法的技艺与之本质不同。" },
  { kobun: "我兵法之利技，义理迥异他流。", translation: "我流兵法中的技法与道理，与其他流派完全不同。" },
  { kobun: "为使世人知兵法之状，特立風之巻，记他流之事也。", translation: "为了让世人了解世间兵法的实情，特设《风之卷》来记述其他流派的内容。" },
  { kobun: "第五曰空之巻。此巻名为空者，盖因言空之始，何为奥，何为口，皆无可定也。", translation: "第五为《空之卷》。之所以称为“空”，是因为一旦说出‘空’，便无法再分什么是深奥、什么是入门。" },
  { 
  kobun: "得道理則離道理，兵法之道自有自在，自得奇特，遇時而知拍子，自然而撃，自然而中，皆空之道也。",
  translation: "真正掌握了道理之后，便能超越道理，在兵法之道中自然获得自由，自然显现出奇妙的效果；随着时机的变化而把握节奏，自然而然出击，自然而然命中——这正是‘空之道’。" 
  },
  {
  kobun: "自然入於實道，故記之於空之卷以傳之。",
  translation: "自然而然地步入真实之道，故将此记载于《空之卷》中以传承之。"
  }

];
</script>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>
